import Input from 'antd/es/input';
import styled from 'styled-components';

import { SearchBarInputStyles } from '@shared/searchBar/styled';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Content = styled.div`
  color: #434343;
  display: inline-flex;
  height: 80px;
  padding: 13px 22px;
  width: 125px;
  flex-direction: column;
`;

export const Label = styled.div`
  color: ${({ theme }) => theme.palette.black};
  font-size: 11px;
  font-weight: 400;
  display: inline-flex;
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 17px;
  font-weight: 600;
  margin-top: 5px;
  display: inline-flex;
`;

export const StyledInput = styled(Input).withConfig({
  shouldForwardProp: (prop) => !['isListingPage'].includes(prop),
})<{ isListingPage?: boolean }>`
  &&& {
    height: ${({ isListingPage }) => (isListingPage ? '40px' : '56px')};
    padding-left: 36px;
    ${SearchBarInputStyles};

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
    }
  }
`;

export const Icon = styled.div<{ isListingPage?: boolean }>`
  pointer-events: none !important;
  position: absolute;
  left: 12px;
  top: ${({ isListingPage }) => (isListingPage ? '10px' : '20px')};
  z-index: 2;
`;

export const InputWrapper = styled.button<{ isOpen?: boolean }>`
  justify-content: ${({ isOpen }) =>
    isOpen ? 'space-around' : 'space-evenly'};
  display: flex;
  flex-direction: column;
  background: transparent;
  border: none !important;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
  gap: 6px;
  display: inline-flex;
  &:focus {
    outline: none;
  }
`;
